import { __ } from '../helpers/i18n';
export function customSelect(reset, selectItemOptions) {
    const init = (selectElement) => {
        const hasSearch = !!selectElement.dataset.search;
        if (reset) {
            selectElement.classList.remove('custom-select-hidden');
            selectElement.parentNode.replaceWith(selectElement);
        }
        if (selectItemOptions) {
            changeValue(selectItemOptions.option, selectItemOptions.selectElement, selectItemOptions.currentOptionElement, selectItemOptions.generatedElement);
            return;
        }
        const hasCustom = selectElement.classList.contains('custom-select-hidden');
        if (hasCustom)
            return;
        const selectClasses = selectElement.classList.toString().split(' ');
        const container = document.createElement('div');
        container.classList.add('custom-select');
        selectElement.parentNode.insertBefore(container, selectElement);
        container.appendChild(selectElement);
        const options = selectElement.options;
        const wrapper = document.createElement('div');
        selectElement.classList.add('custom-select-hidden');
        wrapper.classList.add('custom-select-list');
        selectClasses[0].length && wrapper.classList.add(...selectClasses);
        const currentOptionElement = document.createElement('div');
        currentOptionElement.classList.add('current-option');
        currentOptionElement.innerText = options.length ? options[0].innerText.replace(/(\r\n|\n|\r)/gm, "") : '';
        const cleanListWrapper = document.createElement('div');
        cleanListWrapper.classList.add('clean-list-wrapper');
        if (selectElement.classList.contains('menu-select')) {
            const btnEl = document.createElement('button');
            btnEl.classList.add('close', 'close--top');
            const iconEl = document.createElement('span');
            iconEl.classList.add('icon', 'icon--close-fill');
            btnEl.appendChild(iconEl);
            cleanListWrapper.append(btnEl);
        }
        const cleanList = document.createElement('ul');
        cleanList.classList.add('clean-list');
        Array.from(options).forEach((option) => {
            const li = document.createElement('li');
            li.setAttribute('value', option.value);
            li.setAttribute('data-index', option.index.toString());
            li.setAttribute('tabindex', '-1');
            li.innerHTML = option.innerHTML;
            cleanList.appendChild(li);
        });
        const searchInput = document.createElement('input');
        searchInput.setAttribute('type', 'search');
        searchInput.setAttribute('autocomplete', 'off');
        searchInput.setAttribute('placeholder', __('Szukaj'));
        const searchWrapper = document.createElement('div');
        searchWrapper.classList.add('select-search');
        searchWrapper.appendChild(searchInput);
        if (hasSearch) {
            searchInput.addEventListener('input', () => search(searchInput.value, cleanList.childNodes));
            searchInput.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                }
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    const first = Array.from(cleanList.childNodes).find((el) => el.style.display != 'none');
                    first.focus();
                }
            });
            cleanListWrapper.appendChild(searchWrapper);
        }
        cleanListWrapper.appendChild(cleanList);
        wrapper.appendChild(currentOptionElement);
        wrapper.appendChild(cleanListWrapper);
        selectElement.parentNode.insertBefore(wrapper, selectElement.nextSibling);
        eventSender(selectElement, currentOptionElement, wrapper, hasSearch, searchInput, cleanList.childNodes);
        setMountedValue(selectElement, currentOptionElement, wrapper);
        toggleActive(selectElement);
    };
    const search = (query, list) => {
        list.forEach((el) => {
            if (el.textContent.toLowerCase().includes(query.toLowerCase())) {
                el.style.display = 'block';
            }
            else {
                el.style.display = 'none';
            }
        });
    };
    const resetSearch = (searchInput, list) => {
        searchInput.value = '';
        list.forEach((el) => {
            el.style.display = 'block';
        });
    };
    const toggleActive = (selectElement) => {
        if (selectElement.value !== '') {
            selectElement.parentElement.classList.add('active');
        }
        else {
            selectElement.parentElement.classList.remove('active');
        }
    };
    const setMountedValue = (selectElement, currentOptionElement, generatedElement) => {
        const startedValue = selectElement.parentElement.querySelector(`.custom-select-list li[value="${selectElement.value}"]`);
        changeValue(startedValue, selectElement, currentOptionElement, generatedElement);
    };
    const eventSender = (selectElement, currentOptionElement, generatedElement, hasSearch, searchInput, list) => {
        currentOptionElement && currentOptionElement.addEventListener('click', () => toggleVisibility(generatedElement, hasSearch, searchInput, selectElement));
        const options = selectElement.parentElement.querySelectorAll('.custom-select-list li');
        options.forEach((option) => option.addEventListener('click', () => {
            changeValue(option, selectElement, currentOptionElement, generatedElement);
            selectElement.dispatchEvent(new Event('changeOption'));
        }));
        selectElement.addEventListener('change', () => {
            const selectedOption = options[selectElement.selectedIndex];
            changeValue(selectedOption, selectElement, currentOptionElement, generatedElement);
            selectElement.dispatchEvent(new Event('changeOption'));
        });
        options.forEach((option) => option.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                changeValue(option, selectElement, currentOptionElement, generatedElement);
                selectElement.dispatchEvent(new Event('changeOption'));
            }
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                option.nextElementSibling && option.nextElementSibling.focus();
            }
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prev = option.previousElementSibling;
                if (prev && prev.style.display != 'none') {
                    option.previousElementSibling.focus();
                }
                else {
                    searchInput.focus();
                }
            }
        }));
        window.addEventListener('click', (e) => {
            if (!generatedElement.contains(e.target) || e.target.classList.contains('close')) {
                generatedElement.classList.remove('open');
                resetSearch(searchInput, list);
            }
        });
    };
    const changeValue = (option, selectElement, currentOptionElement, generatedElement) => {
        if (!option)
            return;
        currentOptionElement.innerText = option.innerText.replace(/(\r\n|\n|\r)/gm, "");
        const value = option.getAttribute('value');
        if (selectElement.value != value) {
            selectElement.value = value;
            selectElement.dispatchEvent(new Event('change'));
        }
        selectElement.selectedIndex = parseInt(option.getAttribute('data-index'));
        generatedElement.classList.remove('open');
        toggleActive(selectElement);
    };
    const toggleVisibility = (generatedElement, hasSearch, searchInput, selectElement) => {
        const cssClass = generatedElement.classList;
        if (cssClass.contains('open')) {
            cssClass.remove('open');
            if (hasSearch) {
                searchInput.value = '';
            }
        }
        else {
            selectElement.dispatchEvent(new Event('click'));
            cssClass.add('open');
            if (hasSearch) {
                searchInput.focus();
            }
        }
    };
    const selectElementList = document.querySelectorAll('select:not(.normal)');
    selectElementList && selectElementList.forEach(select => init(select));
}
export function customNumber() {
    let inputs = document.querySelectorAll('input[type="number"]:not(.normal)');
    if (!inputs.length)
        return;
    const countDecimals = (value) => {
        if (Math.floor(value) === value)
            return 0;
        return value.toString().split(".")[1].length || 0;
    };
    const increment = (input, sign) => {
        const inputValue = input.value ? parseFloat(input.value) : 0;
        const inputMin = input.min ? parseFloat(input.min) : -Infinity;
        const inputMax = input.max ? parseFloat(input.max) : Infinity;
        const step = input.step ? parseFloat(input.step) * sign : 1 * sign;
        const decimals = countDecimals(step);
        const newValue = inputValue + step;
        if (newValue >= inputMin && newValue <= inputMax) {
            const rounded = newValue.toFixed(decimals);
            input.value = rounded.toString();
        }
        if (inputValue > inputMax) {
            input.value = inputMax.toString();
        }
        if (inputValue < inputMin) {
            input.value = inputMin.toString();
        }
        input.dispatchEvent(new Event('input'));
    };
    const createButton = (className, icon) => {
        const button = document.createElement('button');
        button.classList.add(className);
        button.type = 'button';
        const buttonIcon = document.createElement('span');
        buttonIcon.classList.add('icon', icon);
        button.appendChild(buttonIcon);
        return button;
    };
    inputs.forEach(input => {
        const hasCustom = input.parentNode.classList.contains('custom-number');
        if (hasCustom)
            return;
        const wrapper = document.createElement('div');
        let wrapperClasses = input.getAttribute('data-wrapper-class');
        if (wrapperClasses) {
            wrapperClasses = wrapperClasses.split(' ');
            wrapper.classList.add(`custom-number`, ...wrapperClasses);
        }
        else {
            wrapper.classList.add(`custom-number`);
        }
        const minus = createButton('btn-subtraction', 'icon--minus');
        const plus = createButton('btn-addition', 'icon--plus');
        minus.ariaLabel = __('Zmniejsz ilość produktów');
        plus.ariaLabel = __('Zwiększ ilość produktów');
        input.parentNode.insertBefore(wrapper, input);
        wrapper.appendChild(minus);
        wrapper.appendChild(input);
        wrapper.appendChild(plus);
        minus.addEventListener("click", () => increment(input, -1));
        plus.addEventListener("click", () => increment(input, 1));
    });
}
